import { FormInstance } from 'antd';
import { formatAmount } from './formatAmount';

type FieldValues = {
  downPaymentPercentage?: number;
  purchasePrice?: number;
  loanAmount?: number;
  propertyValue?: number;
  purchasePriceActive?: boolean;
  calculateFromLoanAmount?: boolean;
  removeDownPayment?: boolean;
}

export const calculateDownPayment = (
  form: FormInstance,
  loanIndex: string | number,
  {
    downPaymentPercentage,
    purchasePrice,
    loanAmount,
    propertyValue,
    purchasePriceActive,
    calculateFromLoanAmount,
    removeDownPayment,
  }: FieldValues = {}
) => {
  const downPaymentPercentageValue = downPaymentPercentage ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'downPaymentPercentage', 'value'])) || 0);

  const purchasePriceValue = purchasePrice ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'purchasePrice', 'value'])) || 0);

  const propertyValueValue = propertyValue ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'externalLoan', 'propertyValue'])) || 0);

  const loanAmountValue = loanAmount ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'loanAmount', 'value'])) || 0);

  const removeDownPaymentValue = removeDownPayment ??
    form.getFieldValue(['loans', loanIndex, 'externalLoan', 'removeDownPayment']);

  const purchasePriceActiveValue = purchasePriceActive ?? form.getFieldValue(['tableView', 'purchasePrice', 'active']);

  if (removeDownPaymentValue) return 0;

  const price = purchasePriceActiveValue ? purchasePriceValue : propertyValueValue;

  if (calculateFromLoanAmount) {
    return parseFloat(formatAmount(Math.max(0, price - loanAmountValue)));
  }

  return parseFloat(formatAmount(price * (downPaymentPercentageValue / 100)));
}
